"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  defaultExtrasProvider: true,
  addExtras: true
};
exports.addExtras = addExtras;
exports.defaultExtrasProvider = void 0;
var _ExtrasProvider = require("./ExtrasProvider");
Object.keys(_ExtrasProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ExtrasProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ExtrasProvider[key];
    }
  });
});
var _DeployedExtra = require("./DeployedExtra");
Object.keys(_DeployedExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DeployedExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DeployedExtra[key];
    }
  });
});
var _LottoExtra = require("./LottoExtra");
Object.keys(_LottoExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _LottoExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LottoExtra[key];
    }
  });
});
var _TransferExtra = require("./TransferExtra");
Object.keys(_TransferExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TransferExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TransferExtra[key];
    }
  });
});
var _UniswapExtra = require("./UniswapExtra");
Object.keys(_UniswapExtra).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _UniswapExtra[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UniswapExtra[key];
    }
  });
});
var _DumbappExtraProcessor = require("./DumbappExtraProcessor");
Object.keys(_DumbappExtraProcessor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DumbappExtraProcessor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappExtraProcessor[key];
    }
  });
});
var _util = require("./util");
Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _util[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _util[key];
    }
  });
});
const defaultExtrasProvider = exports.defaultExtrasProvider = new _ExtrasProvider.ExtrasProvider();
defaultExtrasProvider.addExtra(new _DeployedExtra.DeployedExtraProcessor()).addExtra(new _LottoExtra.LottoExtraProcessor()).addExtra(new _TransferExtra.TransferExtraProcessor()).addExtra(new _UniswapExtra.UniswapExtraProcessor());
async function addExtras(parameters, submission) {
  let ret = {};
  let existing = submission.data.extras || {};
  for (let extra of defaultExtrasProvider.get()) {
    if (existing[extra.key]) {
      continue;
    }
    let value = await extra.process(parameters, submission);
    if (value && value.length > 0) {
      ret[extra.key] = value;
    }
  }
  return ret;
}
//# sourceMappingURL=index.js.map